package com.vizio.redwolf.utils

import kotlin.js.JsExport

@JsExport
interface UamServiceEnvironment: Environment {
    val host: String
    val rewardsPath: String
}

@JsExport
abstract class BaseUamServiceEnvironment : UamServiceEnvironment {
    override val rewardsPath: String = "rewards-flows/v1"
}

@JsExport
data class DevUamServiceEnvironment(
    override val host: String = "dev.uam.plat-svcs.vizio.com"
): BaseUamServiceEnvironment()

@JsExport
data class StageUamServiceEnvironment(
    override val host: String = "stage.uam.plat-svcs.vizio.com"
): BaseUamServiceEnvironment()

@JsExport
data class PreProdUamServiceEnvironment(
    override val host: String = "preprod.uam.plat-svcs.vizio.com"
): BaseUamServiceEnvironment()

@JsExport
data class ProdUamServiceEnvironment(
    override val host: String = "prod.uam.plat-svcs.vizio.com"
): BaseUamServiceEnvironment()

fun chooseUamServiceEnvironment(envConfig: UamServiceEnvironmentConfig): UamServiceEnvironment {
    return when (envConfig.environmentGroup) {
        EnvironmentGroup.PROD -> ProdUamServiceEnvironment()
        EnvironmentGroup.PREPROD -> PreProdUamServiceEnvironment()
        EnvironmentGroup.STAGE -> StageUamServiceEnvironment()
        EnvironmentGroup.DEV -> DevUamServiceEnvironment()
        EnvironmentGroup.TEST -> TODO("TestUamServiceEnvironment() is not defined")
    }
}